const __WEBPACK_NAMESPACE_OBJECT__ = require("userful-chronos-app-common-js/dist/models/config/messages/AdvancedSettingsMessagesSender");